<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.activiteManagement') }}
          </h3>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="row">
         
          <div class="col-lg-4 col-xl-4">
            <router-link :to="{ name: 'ama'}">
              <stats-card
                  :title="$tc('message.ama',2)"
                  type="gradient-orange"
                  icon="fas fa-user"
                  class="mb-4"
              ></stats-card>
            </router-link>
          </div>
          <div class="col-lg-4 col-xl-4">
            <router-link :to="{ name: 'medecin-referent'}">
              <stats-card
                  :title="$tc('message.medecinreferent',2)"
                  type="gradient-orange"
                  icon="fas fa-user"
                  class="mb-4"
              ></stats-card>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from "@/plugins/i18n";
import _ from 'lodash';

export default {
  name: "UserManagement",
  computed: {
    ...mapGetters([
      'groupeActivites',
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPatientRole',
      'hasPraticienRole',
      'hasSouscripteurRole',
      'hasGestionnaireRole']),

    can:function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
    },

    userIsMed:function(){
      return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
    },

    mGroupeActivites:function (){
      let gArray=[];
      _.forEach(this.groupeActivites, function (activite){
        gArray.push({name: (i18n.t(`message.activite.${activite.id}`)).substr(0,65),slug:activite.slug});
      });
      return gArray;
    }
  },

  methods: {
    getGroupeActivites:function (){
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getGroupeActivites', { args : args });
    }
  },

  mounted() {
    this.getGroupeActivites();
  }


}
</script>

<style scoped>

</style>